import { Dispatch, SetStateAction } from 'react';

import fetcher from 'api/fetcher';
import { MagritteNotificationName } from 'utils/constants/notification';

import { loadGalleryImages } from 'components/common/BannerImg/GalleryModal/loadGalleryImages';

import { setSavedImageId } from 'store/models/aiImageGeneration';
import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

type SaveImageToGallery = (props: {
    id: number;
    setSavedImagesLoadings: Dispatch<SetStateAction<Record<number, boolean>>>;
}) => AppThunkAction;

export const saveImageToGallery: SaveImageToGallery = ({ id, setSavedImagesLoadings }) => {
    return async (dispatch) => {
        try {
            setSavedImagesLoadings((prevLoadings: Record<number, boolean>) => ({
                ...prevLoadings,
                [id]: true,
            }));
            void (await fetcher.post(`/api/v1/images/gallery/save?id=${id}`));
            dispatch(setSavedImageId(id));
            dispatch(loadGalleryImages());
            dispatch(addMagritteNotification(MagritteNotificationName.SaveImageToGallerySuccess));
        } catch (e) {
            dispatch(addMagritteNotification(MagritteNotificationName.SaveImageToGallerySomethingWentWrong));
        } finally {
            setSavedImagesLoadings((prevLoadings) => ({
                ...prevLoadings,
                [id]: false,
            }));
        }
    };
};
